import React from "react";
import SimpleBar from "simplebar-react";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";
import EmpresaSelector from "../Components/Common/EmpresaSelector";
import DepartamentoSelector from "../Components/Common/DepartamentoSelector";
import { useDispatch } from "react-redux";
import { changeSidebarVisibility } from "../slices/thunks";

const Sidebar = ({ layoutType }) => {
  const dispatch = useDispatch();
  const handleOcultar = () =>{
     dispatch(changeSidebarVisibility("close"));
  }

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <button
          type="button"
          className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
          onClick={handleOcultar}
          style={{ whiteSpace: 'nowrap' }}
        >
          <span className="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <div className="m-3">
          <EmpresaSelector />
        </div>
        <div className="m-3">
          <DepartamentoSelector />
        </div>
        <React.Fragment>
          <SimpleBar id="scrollbar" className="h-100">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <VerticalLayout layoutType={layoutType} />
              </ul>
            </Container>
          </SimpleBar>
          <div className="sidebar-background"></div>
        </React.Fragment>
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
